import React from 'react';
import Button from '../components/Button';
import Helmet from '../components/Helmet'
import Section from '../components/Section';
import Carousel from '../components/Carousel';
import Clients from '../components/Clients';

import image from './organizacja.jpg';

import carousel1 from '../images/carousel/organizacja/1.jpg';
import carousel2 from '../images/carousel/organizacja/2.jpg';
import carousel3 from '../images/carousel/organizacja/3.jpg';
import carousel4 from '../images/carousel/organizacja/4.jpg';
import carousel5 from '../images/carousel/organizacja/5.jpg';
import carousel6 from '../images/carousel/organizacja/6.jpg';
import carousel7 from '../images/carousel/organizacja/7.jpg';
import carousel8 from '../images/carousel/organizacja/8.jpg';
import carousel9 from '../images/carousel/organizacja/9.jpg';
import carousel10 from '../images/carousel/organizacja/10.jpg';
import carousel11 from '../images/carousel/organizacja/11.jpg';
import carousel12 from '../images/carousel/organizacja/12.jpg';
import carousel13 from '../images/carousel/organizacja/13.jpg';


const images = [
  { resolutions: { src: carousel1 }},
  { resolutions: { src: carousel2 }},
  { resolutions: { src: carousel3 }},
  { resolutions: { src: carousel4 }},
  { resolutions: { src: carousel5 }},
  { resolutions: { src: carousel6 }},
  { resolutions: { src: carousel7 }},
  { resolutions: { src: carousel8 }},
  { resolutions: { src: carousel9 }},
  { resolutions: { src: carousel10 }},
  { resolutions: { src: carousel11 }},
  { resolutions: { src: carousel12 }},
  { resolutions: { src: carousel13 }},
]

const text = `<p><strong>CustomArt</strong> to wieloletnie <strong>doświadczenie w branży</strong>, kilkaset odbytych imprez od kameralnych koncertów po oprawę rozbudowanych konferencji zarówno <strong>w kraju jak i za granicą</strong>. Pozwól, że zaproponujemy ci <strong>kompleksowe rozwiązania</strong> na potrzeby twojego wydarzenia.</p>`;

const seo = 'CustomArt to wieloletnie doświadczenie w branży, kilkaset odbytych imprez od kameralnych koncertów po oprawę rozbudowanych konferencji zarówno w kraju jak i za granicą. Pozwól, że zaproponujemy ci rozwiązania dopasowane do potrzeb twojego wydarzenia.'

const Organization = (props) => {
  const clients = props.data.allContentfulClientList.edges[0].node.clients;
  return (
    <div>
      <Helmet title="Organizacja wydarzeń">
        <meta name="description" content={seo} />
      </Helmet>
      <Section
        isFirstSection
        title="ORGANIZACJA WYDARZEŃ"
        background={image}
        subtitle={text}
      />
      <div className="section__container" style={{ padding: '100px 15px' }}>
      <p>Zajmujemy się <strong>organizacją</strong> wydarzeń stricte muzycznych, przygotowaniem i oprawą integracji firmowych, konferencji, gal rozdania nagród czy pokazów mody. Jesteśmy w stanie przygotować od zera ciekawą koncepcję zarówno na przyjęcie prywatne jak i na duże wydarzenia firmowe. Pokażemy przykłady nietypowych realizacji, zaproponujemy <strong>rozwiązania</strong> dopasowane do ciebie i twoich wymagań, a następnie z uśmiechem na twarzy zrealizujemy <strong>show</strong>  w płynny i profesjonalny sposób.</p>
      <p>Zapraszamy do składania zapytań wszystkich, którzy szukają <strong>oryginalnych koncepcji</strong> i poszukują firmy, która zrealizuje bez problemu ich <strong>najśmielsze wizje </strong>zapewniając najwyższy poziom i najlepszych artystów. Jeśli nie masz jeszcze ani pomysłu, ani wytycznych – <strong>napisz do nas</strong>. Nasza ekipa skontaktuje się z tobą, dopyta o niezbędne kwestie, zbada oczekiwania oraz zaproponuje <strong>najlepsze rozwiązania</strong>.</p>
      </div>
      <Carousel images={images} />
      <section className="text-section" style={{ padding: '100px 15px' }}>
        <h2 className="text-section__title" style={{textAlign: 'center'}}>Zuafali nam</h2>
        <Clients clients={clients} />
      </section>
      <div style={{ textAlign: 'center', padding: '30px 0' }}>
        <Button type="yellow" label="Napisz do nas!" mailto="mailto:kontakt@customart.pl"/>
      </div>
      <div style={{paddingTop: 100}} />
    </div>
  )
}

export default Organization;

export const query = graphql`
  query ClientsQuery {
    allContentfulClientList {
      edges {
        node {
          clients {
            name
            logo {
              resolutions(width: 300) {
                src
              }
            }
          }
        }
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/organizacja-wydarzen.js